import React from "react";

import PropTypes from 'prop-types'
import {  Col } from "reactstrap";

import { ReactComponent as ShameSvg } from '../../../assets/images/shame.svg';
import './style.scss'; 

function BaseBox ({Icon, title, description, degreesShame, colWidth = 4}) {
    return (
        <Col className="box-col" xs={12} md={colWidth}>
            <div className="base-box">
                <ShameSvg style={{transform: `rotate(${degreesShame}deg)`}} className="shame-icon"/>
                <div className="box-overlay">
                    <Icon className="box-icon"/>
                    <h3 className="heading-3">{title}</h3>
                    <p className="body-text">{description}</p>
                </div>
            </div>
        </Col>
    )
}

BaseBox.propTypes = {
  Icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  degreesShame: PropTypes.number.isRequired,
};

export default BaseBox;
